import useWorkspaceAccounts from "common/datahooks/useWorkspaceAccounts";

export default function useLicensedAccounts(workspaceId: string) {
  const { workspaceAccounts } = useWorkspaceAccounts(workspaceId);

  const agencyLicensedAccounts = workspaceAccounts
    ? workspaceAccounts.filter(
        ({ type, license }) => !!license && type === "agency",
      )
    : [];
  const outreachLicensedAccounts = workspaceAccounts
    ? workspaceAccounts.filter(
        ({ type, license }) => !!license && type === "user",
      )
    : [];

  return { agencyLicensedAccounts, outreachLicensedAccounts };
}
